import { render } from "./ToolPageHeader.vue?vue&type=template&id=6bcb6888&scoped=true"
import script from "./ToolPageHeader.vue?vue&type=script&lang=js"
export * from "./ToolPageHeader.vue?vue&type=script&lang=js"

import "./ToolPageHeader.vue?vue&type=style&index=0&id=6bcb6888&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcb6888"]])

export default __exports__